import { EventClient } from "@tanstack/devtools-event-client";
class DevtoolsEventClient extends EventClient {
  constructor() {
    super({
      pluginId: "tanstack-devtools-core"
    });
  }
}
const devtoolsEventClient = new DevtoolsEventClient();
export {
  DevtoolsEventClient,
  devtoolsEventClient
};
//# sourceMappingURL=index.js.map
